// frontend/src/components/layout/StatusBar.jsx
import React, { useState, useEffect } from "react"
import { useSelector }                 from "react-redux"
import { selectUser }                  from "../../features/userSlice"
import {
  selectActiveTabId,
  selectTabs,
}                                      from "../../features/tabsSlice"
import "./StatusBar.css"

const StatusBar = () => {
  const user        = useSelector(selectUser)
  const activeTabId = useSelector(selectActiveTabId)
  const openTabs    = useSelector(selectTabs)

  const [poolStatus, setPoolStatus] = useState({
    open: 4, inUse: 1, ms: 2
  })
  const [time, setTime] = useState(new Date())

  // ── Live clock ────────────────────────────────────────────
  useEffect(() => {
    const t = setInterval(() => setTime(new Date()), 30000)
    return () => clearInterval(t)
  }, [])

  // ── Poll Oracle pool health every 30s ─────────────────────
  useEffect(() => {
    const check = async () => {
      try {
        const r = await fetch("/api/health/db")
        if (r.ok) {
          const d = await r.json()
          setPoolStatus({
            open:  d.connectionsOpen  || 4,
            inUse: d.connectionsInUse || 1,
            ms:    d.responseMs       || 2,
          })
        }
      } catch { /* silent — not critical */ }
    }
    check()
    const t = setInterval(check, 30000)
    return () => clearInterval(t)
  }, [])

  const activeTab = openTabs?.find(t => t.id === activeTabId)
  const now       = new Date()
  const month     = now.getMonth() + 1
  const quarter   = `Q${Math.ceil(month / 3)}`
  const fy        = month >= 4
    ? `${now.getFullYear()}-${String(now.getFullYear() + 1).slice(2)}`
    : `${now.getFullYear() - 1}-${String(now.getFullYear()).slice(2)}`

  const timeStr = time.toLocaleTimeString("en-IN", {
    hour:   "2-digit",
    minute: "2-digit",
    hour12: true,
  })

  return (
    <div className="status-bar">

      {/* Oracle Pool */}
      <div className="sb-item">
        <div className="sb-pool-dot" />
        <span>Oracle Pool</span>
        <b>{poolStatus.open}/{20}</b>
        <span className="sb-muted">· {poolStatus.inUse} active · {poolStatus.ms}ms</span>
      </div>

      <div className="sb-sep" />

      {/* Financial Year */}
      <div className="sb-item">
        <span>FY</span>
        <b>{fy}</b>
        <span className="sb-muted">{quarter}</span>
      </div>

      <div className="sb-sep" />

      {/* Entity */}
      <div className="sb-item">
        <span>Entity:</span>
        <b>{user?.entity || "—"}</b>
      </div>

      {/* Division */}
      {user?.division && (
        <>
          <div className="sb-sep" />
          <div className="sb-item">
            <span>Div:</span>
            <b>{user.division}</b>
          </div>
        </>
      )}

      <div className="sb-sep" />

      {/* Active form */}
      <div className="sb-item">
        <span>Form:</span>
        <b>{activeTab?.label || "Dashboard"}</b>
      </div>

      {/* Tab count */}
      {openTabs?.length > 0 && (
        <>
          <div className="sb-sep" />
          <div className="sb-item">
            <span>Tabs:</span>
            <b>{openTabs.length}</b>
            <span className="sb-muted">/ 8</span>
          </div>
        </>
      )}

      {/* Spacer */}
      <div className="sb-spacer" />

      {/* User */}
      <div className="sb-item">
        <span>User:</span>
        <b>{user?.emp_id || "—"}</b>
      </div>

      <div className="sb-sep" />

      {/* Time */}
      <div className="sb-item">
        <b>{timeStr}</b>
      </div>

      <div className="sb-sep" />

      {/* Shortcuts help */}
      <button
        className="sb-shortcut-btn"
        title="Keyboard shortcuts"
        onClick={() =>
          alert(
            "Keyboard Shortcuts\n" +
            "──────────────────\n" +
            "Ctrl+K   Search / Command Palette\n" +
            "Ctrl+B   Toggle Sidebar\n" +
            "Ctrl+S   Save active form\n" +
            "Ctrl+W   Close active tab\n" +
            "Esc      Close panel / palette"
          )
        }
      >
        ⌨ Shortcuts
      </button>

    </div>
  )
}

export default StatusBar